import { Component, OnInit } from '@angular/core';
import { ProductService } from "../services/product/product.service";
import { CategoryService } from '../services/category/category.service';
import { environment } from "../../environments/environment";
import { ActivatedRoute, ParamMap } from '@angular/router';
@Component({
  selector: 'app-marque',
  templateUrl: './marque.component.html',
  styleUrls: ['./marque.component.css']
})
export class MarqueComponent implements OnInit {
   categories=[];
   products
   pageSize = 12;
   page;
   total;
   brand;
   idsCategories=[];
   idFournisseur;
   listF1=[];
   listF2=[];
   listF3=[];
   baseUrl = environment.baseUrl

  constructor(private productService:ProductService,private route: ActivatedRoute,private categoryService:CategoryService) { }

  ngOnInit(): void {
    // Initialize pagination
    this.page = 1;
    
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idFournisseur = params.get('id')

      this.categoryService.allCategories().subscribe(res =>{
         this.brand = res['fournisseurs'][this.idFournisseur]
         this.formatDataCategories(Object.entries(res['categories']));

      })

      this.loadProducts();
    })
  }

  loadProducts() {
    if (this.idsCategories.length > 0) {
      // Load products with category filter
      this.productService.productByMarkCategories(this.idFournisseur, this.idsCategories, this.page, this.pageSize).subscribe(res => {
        this.products = res['products'];
        
        // Set total for pagination
        if (res['total']) {
          this.total = res['total'];
        } else {
          this.total = this.products ? this.products.length : 0;
        }
        
        this.updateCategories();
      });
    } else {
      // Load all products for the brand
      this.productService.getProductByMarque(this.idFournisseur, this.page, this.pageSize).subscribe(res => {
        this.products = res['products'];
        
        // Set total for pagination
        if (res['total']) {
          this.total = res['total'];
        } else {
          this.total = this.products ? this.products.length : 0;
        }
        
        this.updateCategories();
      });
    }
  }

  updateCategories() {
    this.categories = [];
    var catTemp = [];

    if (this.products) {
      this.products.forEach(p => {
        catTemp.push(p.TSICOD2);
      });

      catTemp = [...new Set(catTemp)];
      this.listF3.forEach(f3 => {
        if (catTemp.includes(f3.id)) {
          this.categories.push(f3);
        }
      });
    }
  }

  onPageChange(numPage: number) {
    this.page = numPage;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    // Reload products for the new page
    this.loadProducts();
  }


  changeMax(nbrProducts){
    this.pageSize = Number(nbrProducts);
    // Reset pagination to page 1 when changing items per page
    this.page = 1;
    // Reload products with new page size
    this.loadProducts();
  }

  filtrebyCategories(idCat,event)
  {
    if (!idCat) return;
    
    // Reset pagination to page 1 when filter changes
    this.page = 1;
    
    if ( event.target.checked ) {
      this.idsCategories.push(idCat)
      this.idsCategories = [...new Set(this.idsCategories)];
    }else{
      const index = this.idsCategories.indexOf(idCat);
      if (index > -1) {
          this.idsCategories.splice(index, 1); // 2nd parameter means remove one item only
      }
    }

    // Reload products with filter and pagination
    this.loadProducts();
  }


  formatDataCategories(categories)
  {

    var objectTemp = {id:'',titre:'',categories:{},parent:null};
    for (let i = 0; i < categories.length; i++)
    {
      objectTemp = categories[i][1];
      objectTemp.id = categories[i][0];
      this.listF1.push(objectTemp);
    }

    var f2Temp;
    this.listF1.forEach(f1 => {
      f2Temp = Object.entries(f1.categorie);
      for (let i = 0; i < f2Temp.length; i++)
      {
        objectTemp = f2Temp[i][1];
        objectTemp.id = f2Temp[i][0];
        objectTemp.parent =  f1.id;
        this.listF2.push(objectTemp);
      }
    });

    var f3Temp;
    this.listF2.forEach(f2 => {

      if (f2.categories != undefined && f2.categories.length!=0  ) {

        f3Temp = Object.entries(f2.categories);

        for (let i = 0; i < f3Temp.length; i++)
        {
          objectTemp.titre = f3Temp[i][1];
          objectTemp.id = f3Temp[i][0];
          objectTemp.parent =  f2.id;
          this.listF3.push(objectTemp);
          objectTemp = {id:'',titre:'',categories:{},parent:null};
        }
      }
    });

  }

}
